import React, { useEffect, createElement } from 'react';
const PIXEL_ID = '1376744403856001';
declare global {
  interface Window {
    fbq?: any;
    _fbq?: any;
  }
}
export function MetaPixel() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    // If fbq is already initialized, just track PageView
    if (window.fbq) {
      try {
        window.fbq('track', 'PageView');
      } catch (e) {
        // no-op
      }
      return;
    }
    try {
      // Initialize fbq shim
      const n: any = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      window.fbq = n;
      if (!window._fbq) window._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      // Inject Meta Pixel script into <head> (safer than getElementsByTagName)
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const target = document.head || document.body || document.documentElement;
      if (target) {
        target.appendChild(script);
      }
      window.fbq('init', PIXEL_ID);
      window.fbq('track', 'PageView');
    } catch (e) {
      // Fail silently — pixel issues should never break the page
      console.warn('Meta Pixel initialization failed:', e);
    }
  }, []);
  return <noscript data-id="element-263">
      <img height="1" width="1" style={{
      display: 'none'
    }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-264" />
    </noscript>;
}